// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*::-webkit-scrollbar {
  width: 0 !important;
}

:host {
    width: 100%;
}
.titulos {
    text-align: center;
}

.kyc-container {
  width: 100%;
  margin: 0 auto;
  padding: 0 0 150px;
  overflow-y: scroll;
  height: 88vh;
}

.tabsPoints, .points {
  padding: 0 1%;
}

.tabsPoints > div {
  width: 25%;
  text-align: center;
}

.active {
  transition: color 0.3s ease;
  opacity: 1;
}

.active > div > strong {
  color: #f09502 !important;
}

.opacity {
  opacity: 0.7;
}

.kyc-container form {
  margin-bottom: 50px;
}

.bottonsToNav button {
  display: inline-block;
  margin-right: 10px;
}

.bottonsToNav button:first-child i {
  display: inline-block;
  margin-right: 5px;
}

.bottonsToNav button:last-child i {
  display: inline-block;
  margin-left: 5px;
}

.bottonsToNav button:nth-child(3) i {
  display: inline-block;
  margin-right: 5px;
}

.bottonsToNav button:nth-child(4) i {
  display: inline-block;
  margin-left: 5px;
}

.new-container {
  width: 98.5%;
  margin: 0 12px; 
}

.errorInput {
  background-color: rgb(255, 196, 196);
}

.kyc-containerButtons {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: stretch;
}

.iframe-container {
  width: 100%;
  min-height: 90vh;
}

.iframe-container body {
  overflow: scroll;
}

.verif{
  margin-top: 3%;
  border: 2px solid #f09502;
  height: 34.7em;
}

.d-flex {
  display: flex!important;
  flex-wrap: wrap;
  margin: 0 auto;
}

.row {
  --bs-gutter-x: -0.5rem;
}

.new-container form {
  background-color: #0e0f15;
  color: white;
  width: 100%;
  border: 2px solid #f09502;
  padding: 40px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.new-container form > div {
width: 47.5%;
  margin: 4px 5px;
}

.new-container form label {
  margin-bottom: 3px;
  font-size: small;
}

.small-line {
  width: 5px;
  margin-top: -3%;
}
  
.line-cicle {
  border-bottom: 4px solid #f09502 !important;
  padding-bottom: 30px;
  position: relative;
}

.line-cicle:before,
.line-cicle:after {
  position: absolute;
  bottom: -12px;
  left: 0;
  width: 20px;
  height: 20px;
  background: #f09502 !important;
  content: "";
  border-radius: 10px;
}

.line-cicle:after {
  right: 0;
  left: auto;
}
  
.line-one-cicle {
  border-bottom: 4px solid #c5c5c5;
  padding-bottom: 30px;
  position: relative;
}

.line-one-cicle:after {
  position: absolute;
  bottom: -12px;
  left: 0;
  width: 20px;
  height: 20px;
  background: #c5c5c5;
  content: "";
  border-radius: 10px;
}

.line-one-cicle:after {
  right: 0;
  left: auto;
}

.line-one-cicle-dark {
  border-bottom: 4px solid #f09502;
  padding-bottom: 30px;
  position: relative;
}

.line-one-cicle-dark:after {
  position: absolute;
  bottom: -12px;
  left: 0;
  width: 20px;
  height: 20px;
  background: #f09502;
  content: "";
  border-radius: 10px;
}

.line-one-cicle-dark:after {
  right: 0;
  left: auto;
}
.space {
  margin-left: 5%;
}

.kycstylebuttons {
  width: 100%;
  margin-top: 35em;
  position: absolute;
}
  
.custom-btn-black {
  white-space: nowrap;
  font-size: 1.1rem !important;
  width: auto !important;
  height: 5% !important;
  border-radius: 12px;
  border-width: 1%;
  margin-top: 20px;
  margin-left: 1%;
  padding: 8px;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 30px;
  color: #ffffff;
  z-index: 5;
  background-color: #f09502;
}

.swal-wide {
  width: 158em !important;
}

input[type='file'] {
  color: transparent;
}

.swal-text{
  max-height: 116em;  /* To be adjusted as you like */
  overflow-y: scroll;
  width: 100%;
}

.swal-popup{
  width: 63em
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #FFF;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.custom-btn-no-bg {
  margin-top: 20px;
  font-size: 1.1rem !important;
  width: 25% !important;
  border-radius: 10px;
  background-color: #f09502;
  padding: 15px;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 30px;
  color: #fcfbf8;
  border: 2px solid black;
  z-index: -5;
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  min-height: 550px;
  border: none;
}

.alladodiv{
  float:left;
}

.alladodiv1{
  float:right;
  align-items:center;
}

.formout{
  color: #fcfbf8;
}

@media (max-width: 500px) {
  .tabsPoints > div {
    width: 100%;
    margin-bottom: 8px;
  }

  .points {
    display: none;
  }

  .new-container {
    width: 100%;
    margin: 0;
  }

  .new-container form {
    width: 100%;
    margin: 0 auto 20px;
    padding: 15px 4%;
  }

  .new-container form > div {
    width: 99%;
    margin-bottom: 5px !important;
  }

  .new-container form > hr {
    display: none;
  }

  .kyc-container{
      width: 97%;
      margin: 0 auto;
      padding: 0 0 300px;
      margin-bottom: 1%;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: wrap;
      overflow-y: auto;
      height: 98vh;
      box-sizing: border-box;
  }

  .bottonsToNav button {
    display: inline-block;
    width: 100%;
    margin-right: 0;
  }

  .bottonsToNav button:first-child {
    margin-bottom: 8px;
  }

  .new-container{
    display: flex;
    flex-direction: column;
    line-height: 23.5px;
  }

  .botones {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/kyc/kyc.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;AACA,YAAY;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,GAAG,+BAA+B;EACnD,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;MACI,UAAU;MACV,cAAc;MACd,kBAAkB;MAClB,iBAAiB;MACjB,8BAA8B;MAC9B,uBAAuB;MACvB,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,sBAAsB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["*::-webkit-scrollbar {\n  width: 0 !important;\n}\n\n:host {\n    width: 100%;\n}\n.titulos {\n    text-align: center;\n}\n\n.kyc-container {\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 0 150px;\n  overflow-y: scroll;\n  height: 88vh;\n}\n\n.tabsPoints, .points {\n  padding: 0 1%;\n}\n\n.tabsPoints > div {\n  width: 25%;\n  text-align: center;\n}\n\n.active {\n  transition: color 0.3s ease;\n  opacity: 1;\n}\n\n.active > div > strong {\n  color: #f09502 !important;\n}\n\n.opacity {\n  opacity: 0.7;\n}\n\n.kyc-container form {\n  margin-bottom: 50px;\n}\n\n.bottonsToNav button {\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.bottonsToNav button:first-child i {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.bottonsToNav button:last-child i {\n  display: inline-block;\n  margin-left: 5px;\n}\n\n.bottonsToNav button:nth-child(3) i {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.bottonsToNav button:nth-child(4) i {\n  display: inline-block;\n  margin-left: 5px;\n}\n\n.new-container {\n  width: 98.5%;\n  margin: 0 12px; \n}\n\n.errorInput {\n  background-color: rgb(255, 196, 196);\n}\n\n.kyc-containerButtons {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  align-items: stretch;\n}\n\n.iframe-container {\n  width: 100%;\n  min-height: 90vh;\n}\n\n.iframe-container body {\n  overflow: scroll;\n}\n\n.verif{\n  margin-top: 3%;\n  border: 2px solid #f09502;\n  height: 34.7em;\n}\n\n.d-flex {\n  display: flex!important;\n  flex-wrap: wrap;\n  margin: 0 auto;\n}\n\n.row {\n  --bs-gutter-x: -0.5rem;\n}\n\n.new-container form {\n  background-color: #0e0f15;\n  color: white;\n  width: 100%;\n  border: 2px solid #f09502;\n  padding: 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.new-container form > div {\nwidth: 47.5%;\n  margin: 4px 5px;\n}\n\n.new-container form label {\n  margin-bottom: 3px;\n  font-size: small;\n}\n\n.small-line {\n  width: 5px;\n  margin-top: -3%;\n}\n  \n.line-cicle {\n  border-bottom: 4px solid #f09502 !important;\n  padding-bottom: 30px;\n  position: relative;\n}\n\n.line-cicle:before,\n.line-cicle:after {\n  position: absolute;\n  bottom: -12px;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  background: #f09502 !important;\n  content: \"\";\n  border-radius: 10px;\n}\n\n.line-cicle:after {\n  right: 0;\n  left: auto;\n}\n  \n.line-one-cicle {\n  border-bottom: 4px solid #c5c5c5;\n  padding-bottom: 30px;\n  position: relative;\n}\n\n.line-one-cicle:after {\n  position: absolute;\n  bottom: -12px;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  background: #c5c5c5;\n  content: \"\";\n  border-radius: 10px;\n}\n\n.line-one-cicle:after {\n  right: 0;\n  left: auto;\n}\n\n.line-one-cicle-dark {\n  border-bottom: 4px solid #f09502;\n  padding-bottom: 30px;\n  position: relative;\n}\n\n.line-one-cicle-dark:after {\n  position: absolute;\n  bottom: -12px;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  background: #f09502;\n  content: \"\";\n  border-radius: 10px;\n}\n\n.line-one-cicle-dark:after {\n  right: 0;\n  left: auto;\n}\n.space {\n  margin-left: 5%;\n}\n\n.kycstylebuttons {\n  width: 100%;\n  margin-top: 35em;\n  position: absolute;\n}\n  \n.custom-btn-black {\n  white-space: nowrap;\n  font-size: 1.1rem !important;\n  width: auto !important;\n  height: 5% !important;\n  border-radius: 12px;\n  border-width: 1%;\n  margin-top: 20px;\n  margin-left: 1%;\n  padding: 8px;\n  font-family: \"Montserrat\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 24px;\n  line-height: 30px;\n  color: #ffffff;\n  z-index: 5;\n  background-color: #f09502;\n}\n\n.swal-wide {\n  width: 158em !important;\n}\n\ninput[type='file'] {\n  color: transparent;\n}\n\n.swal-text{\n  max-height: 116em;  /* To be adjusted as you like */\n  overflow-y: scroll;\n  width: 100%;\n}\n\n.swal-popup{\n  width: 63em\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #FFF;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n.custom-btn-no-bg {\n  margin-top: 20px;\n  font-size: 1.1rem !important;\n  width: 25% !important;\n  border-radius: 10px;\n  background-color: #f09502;\n  padding: 15px;\n  font-family: \"Montserrat\", sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 24px;\n  line-height: 30px;\n  color: #fcfbf8;\n  border: 2px solid black;\n  z-index: -5;\n}\n\niframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  min-height: 550px;\n  border: none;\n}\n\n.alladodiv{\n  float:left;\n}\n\n.alladodiv1{\n  float:right;\n  align-items:center;\n}\n\n.formout{\n  color: #fcfbf8;\n}\n\n@media (max-width: 500px) {\n  .tabsPoints > div {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n\n  .points {\n    display: none;\n  }\n\n  .new-container {\n    width: 100%;\n    margin: 0;\n  }\n\n  .new-container form {\n    width: 100%;\n    margin: 0 auto 20px;\n    padding: 15px 4%;\n  }\n\n  .new-container form > div {\n    width: 99%;\n    margin-bottom: 5px !important;\n  }\n\n  .new-container form > hr {\n    display: none;\n  }\n\n  .kyc-container{\n      width: 97%;\n      margin: 0 auto;\n      padding: 0 0 300px;\n      margin-bottom: 1%;\n      justify-content: space-between;\n      align-items: flex-start;\n      flex-wrap: wrap;\n      overflow-y: auto;\n      height: 98vh;\n      box-sizing: border-box;\n  }\n\n  .bottonsToNav button {\n    display: inline-block;\n    width: 100%;\n    margin-right: 0;\n  }\n\n  .bottonsToNav button:first-child {\n    margin-bottom: 8px;\n  }\n\n  .new-container{\n    display: flex;\n    flex-direction: column;\n    line-height: 23.5px;\n  }\n\n  .botones {\n    display: flex;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
